


















































































import { Component, Vue, Prop } from 'vue-property-decorator'
import { namespace } from 'vuex-class'

import XDialog from '@finance/ssvue/src/components/x-dialog/index.vue'
import IconTitle from '$components/icon-title'
import { formatDate } from '$utils/filters'

const actModule = namespace('freeOrder')

@Component({
  name: 'rule-pop',
  components: {
    IconTitle,
    XDialog
  }
})
export default class RulePop extends Vue {
  @Prop({ default: false }) readonly value!: boolean
  @actModule.Getter actConfig!: any
  format = 'YYYY年M月D日hh:mm:ss'
  formatDate = formatDate
  handleClickClose() {
    this.$emit('input', false)
  }
}
